import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = (location) => {
  // const location = useLocation();
  console.log(location, "location");
  
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-R78R5984G1", {
        page_path: location.pathname + location.search,
      });
    }
    console.log(window.gtag, "window.gtag");
  }, [location]);
};

export default usePageTracking;
